import { Box, IconButton, List, Tooltip } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { useAuthContext } from "../../../hooks/Auth";

import { useNavigate } from "react-router-dom";
import { getSidebarItems } from "../../../data/drawerItems";
import "../animation.css";
import CustomDrawer from "../CustomDrawer";
import animatedImages from "../icons/animatedImages.svg";
import animatedImagesFill from "../icons/animatedImagesFill.svg";
import { Icons } from "./Icons";
import SidebarItem from "./SidebarItem";

interface Props {
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const Sidebar: FC<Props> = ({ setDrawerOpen, drawerOpen }) => {
  const { user, logout } = useAuthContext();
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const [animateIcon, setAnimateIcon] = useState(false);

  const handleOptionClick = (path: string) => {
    navigate("/asistente/" + path);
    setDrawerOpen(false); // Cierra el Drawer en cualquier dispositivo
  };

  const handleUserProfile = () => {
    navigate("/asistente/userprofile");
  };

  //Creamos los items del sidebar
  const sidebarItems = getSidebarItems(user);

  useEffect(() => {
    setAnimateIcon(true); // Activar animación al cargar

    const timer = setTimeout(() => {
      setAnimateIcon(false); // Detener animación después de 3 segundos
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <CustomDrawer
      open={drawerOpen}
      variant="permanent"
      sx={{
        "& .MuiDrawer-paper": {
          border: 1,
          borderTopRightRadius: 15,
          borderBottomRightRadius: 15,
          borderColor: "divider",
          height: "90%", // Altura total del Drawer
          boxShadow: 3,
          mt: 10,
          backgroundColor: "#FFFFF",
          overflowY: "auto",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%", // Asegura que el Box llene el Drawer
          justifyContent: "space-between", // Empuja el contenido abajo
        }}
      >
        {/* Menú UmmIApps */}
        <List>
          {sidebarItems.map((item) => (
            <SidebarItem
              key={item.text}
              Icon={item.icon}
              handleClick={() => handleOptionClick(item.path)}
              text={item.text}
            />
          ))}
        </List>

        {/* Tutoriales */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            py: 2,
            my: 1,
          }}
        >
          <Tooltip
            title={"Tutoriales"}
            placement="right"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#1D3D4D",
                  color: "#FFF",
                  fontFamily: "Montserrat",
                  fontSize: "0.875rem",
                  padding: "8px 12px",
                  borderRadius: "8px",
                },
              },
              arrow: {
                sx: {
                  color: "#1D3D4D", // Color de la flecha
                },
              },
            }}
          >
            <IconButton
              onClick={() =>
                window.open("https://ummia.cl/tutoriales-ummia/", "_blank")
              }
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              sx={{
                "&:hover": {
                  backgroundColor: "transparent",
                  transform: "scale(1.1)",
                  transition: "transform 0.10s ease",
                },
                "&:hover .MuiTypography-root": {
                  fontWeight: "bold",
                },
              }}
            >
              <img
                src={isHovered ? animatedImages : animatedImagesFill}
                alt="Icono Tutorial"
                width={36}
                height={36}
                className={animateIcon ? "bounce-on-load" : ""}
                style={{ transition: "transform 0.2s ease-in-out" }}
              />
            </IconButton>
          </Tooltip>
        </Box>

        {/* Menú cuenta */}
        <List>
          <SidebarItem
            Icon={Icons.Account}
            text={user?.name ? user.name : "Usuario"}
            handleClick={handleUserProfile}
          />

          <SidebarItem
            Icon={Icons.Exit}
            text="Cerrar sesión"
            handleClick={logout}
          />
        </List>
      </Box>
    </CustomDrawer>
  );
};

export default Sidebar;
